import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { formatTel } from '~/utils/common';

import type { TypeStockReleaseCenter } from '~/types/stock.types';

/**
 * [재고관리 > 반출 요청 관리] 반출 요청 상세 > 반출 출발지 센터 정보 테이블
 */
const getStockReleaseDetailCentersColumnDefs = () => {
  const getRowId = (row: TypeStockReleaseCenter) => String(row.vendorReleaseCenterId);

  const columnDefs: TypeTableColumn<TypeStockReleaseCenter>[] = [
    {
      accessorKey: 'temperatureCodeObject.name',
      header: '보관 유형',
      size: 80,
    },
    {
      accessorKey: 'phoneNumber',
      header: '반출 출발지 번호',
      size: 130,
      cell: ({ getValue }) => {
        const value = getValue<TypeStockReleaseCenter['phoneNumber']>();
        return value ? formatTel(value) : '-';
      },
    },
    {
      id: 'address',
      header: '반출 출발지 주소',
      accessorFn: (row) => [row.address, row.detailAddress].filter(Boolean).join(' '),
      meta: { flex: true },
    },
  ];

  return { getRowId, columnDefs };
};

export default getStockReleaseDetailCentersColumnDefs;
